import request from '@/utils/request'

// 리스트 조회
export function getImprovementMeasuresList(param, isNotify) {
  return request({
    url: `/api/getImprovementMeasuresList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
}

// 저장
export function saveImprovementMeasures (param, isNotify) {
  return request({
    url: `/api/saveImprovementMeasures`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'saved' },
  })
}
// 삭제
export function deleteImprovementMeasures (param, isNotify) {
  return request({
    url: `/api/deleteImprovementMeasures`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'deleted' },
  })
}

// 출력
export function getImprovementMeasuresReport (param, isNotify) {
  let responseType = "blob"
  return request({
    url: `/api/getImprovementMeasuresReport`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    responseType: responseType,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
}